import { actionTree, getterTree, mutationTree } from 'typed-vuex'

import { member_login, MemberLoginReq } from '@/api'
import { member_my_info } from '@/api/modules/member_my_info'
import tokenManage from '@/common/tokenManage'

import { accessor } from '../accessor'

export const state = () => ({
  isLogin: !!tokenManage.sid,

  id: null as number | null,

  /** 新用户 */
  new_member: (localStorage.getItem('new_member') ?? '0') === '1',

  face: '',
  nickname: '',

  // 加载锁
  __loadInfoLock: false,
})

export const getters = getterTree(state, {

  /**
   * 是否为新用户
   * @description 与 state.new_member 重名可以强制外界使用 getters.new_member
   */
  new_member: (state) => {
    return state.isLogin ? state.new_member : false
  },

  face: (state) => state.face,
  nickname: (state) => state.nickname,
})

export const mutations = mutationTree(state, {

  /** 删除新用户标志 */
  clearNewMember (state) {
    localStorage.removeItem('new_member')
    state.new_member = false
  },

  reset (ctx) {
    Object.assign(ctx, state())
  },
})

export const actions = actionTree({ state, getters }, {

  /** 用户登录 */
  async login (ctx, data: MemberLoginReq) {
    return member_login(data).then((res) => {
      if (res.data.error_code === 0) {
        tokenManage.sid = res.data.info.msid

        const { new_member } = res.data.info

        // 设置缓存
        localStorage.setItem('new_member', new_member ? '1' : '0')

        ctx.state.new_member = new_member
        ctx.state.isLogin = !!tokenManage.sid

        accessor.member.loadInfo()
      }
      return res
    })
  },

  /** 加载用户信息，不会返回任何内容 */
  async loadInfo (ctx) {
    if (ctx.state.__loadInfoLock) {
      return
    }

    ctx.state.__loadInfoLock = true

    const { data } = await member_my_info()
    if (data.error_code === 0) {
      ctx.state.id = data.info.id
      ctx.state.face = data.info.face
      ctx.state.nickname = data.info.nickname
    }

    ctx.state.__loadInfoLock = false
  },

})

export const namespaced = true
